import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const IPay88ResultMob = () => {
  return <CommonResult />;
};

export default IPay88ResultMob;
